export const envConfig = {
  "VITE_COGNITO_REGION": "",
  "VITE_COGNITO_USER_POOL_ID": "",
  "VITE_COGNITO_CLIENT_ID": "",
  "VITE_COGNITO_DOMAIN": "",
  "VITE_COGNITO_REDIRECT_URI": "",
  "VITE_API_KEY": "",
  "VITE_API_BASE_URL": "",
  "VITE_SKIP_START": "",
  "VITE_TEST_COMPONENTS_VIEW": "",
  "VITE_VAPID_PUBLIC_KEY": "",
  "VITE_STAGE": "",
  "VITE_DD_APPLICATION_ID": "",
  "VITE_DD_CLIENT_TOKEN": "",
  "VITE_DD_SITE": "datadoghq.com",
  "VITE_DD_SERVICE": "ia-eva",
  "VITE_DD_ENV": "dev",
  "BUILD_VERSION": "20261029.6-1b03458",
  "VITE_DD_VERSION": "20261029.6-1b03458",
  "VITE_DD_TRACING_ENABLED": "",
  "VITE_DD_CLIENT_METRICS_ENABLED": "",
  "VITE_DD_SESSION_SAMPLE_RATE": "100",
  "VITE_DD_SESSION_REPLAY_SAMPLE_RATE": "100",
  "VITE_WORKSPACE_SCAN_INTERVAL_MS": "",
  "VITE_WORKSPACE_SCAN_MOVEMENT_TICKS": "",
  "VITE_WORKSPACE_SCAN_DIFF_THRESHOLD": "",
  "VITE_NETWORK_PING_THRESHOLD_MS": "",
  "VITE_NETWORK_PING_WARN_MS": "",
  "VITE_NETWORK_BAD_PING_LIMIT": "",
  "VITE_PROCTORING_TAB_SINGLETON_PRESET": "",
  "VITE_PROCTORING_SIDE_PANEL_PRESET": "",
  "VITE_PROCTORING_MULTI_MONITOR_PRESET": "",
  "VITE_PROCTORING_ANTI_CHEAT_SIGNALS_PRESET": ""
};